<template>
    <b-overlay :show="tableLoading" rounded="sm">
    <b-card class="audit-log">
        <!-- filter section -->
        <b-row class="gx-2">
            <b-col cols="12" md="6">
                <b-form-input class="lh-base" :placeholder="$translate('search_filter')"
                    addon-right-icon="ni ni-zoom-split-in" v-model="query"></b-form-input>
            </b-col>
            <b-col cols="12" md="6" class="mt-2 mt-md-0 dd">
                <b-form-select class="form-control" id="type" v-model="filters.type" :options="auditTypes">
                    <template #first>
                        <b-form-select-option :value="null">{{ $translate('select_type') }}</b-form-select-option>
                    </template>
                </b-form-select>
            </b-col>
        </b-row>
        <b-row class="mt-2 gx-2 ">
            <b-col cols="12" md="6" class="dd">
                <b-form-select class="form-control" id="user" v-model="filters.user_id" :options="users">
                    <template #first>
                        <b-form-select-option :value="null">{{ $translate('select_user') }}</b-form-select-option>
                    </template>
                </b-form-select>
            </b-col>

            <b-col cols="6" md="3" class="mt-2 mt-md-0">
                <b-form-input placeholder="Date From" type="date" class="lh-base"
                    v-model="filters.date_from"></b-form-input>
            </b-col>

            <b-col cols="6" md="3" class="mt-2 mt-md-0">
                <b-form-input placeholder="Date To" type="date" class="lh-base" v-model="filters.date_to"></b-form-input>
            </b-col>
        </b-row>
        <b-card-body>
            <b-col class="page-block"><strong>{{ $translate('page') }}: {{ pagination.page }} {{ $translate('of') }} {{
                pageCount }} {{ $translate('total') }}:
                    {{ pagination.total }}</strong></b-col>
            <b-col class="overflow-auto w-100 mt-4">
                <!-- table to display the audit logs -->
                <b-table responsive :items="auditLogs" :busy="tableLoading" :fields="fields">
                    <!-- field templates -->
                    <!-- <template #table-busy>
                        <div class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                    </template> -->
                    <!-- display the role as the first and last name of the user -->
                    <template #cell(role)="{ item }">
                        <span>
                            {{ item.user.first_name + ' ' + item.user.last_name }}
                        </span>
                    </template>

                    <!-- display the message as html -->
                    <template #cell(message)="{ item }">
                        <span class="lh-base" v-html="item.message"></span>
                    </template>
                </b-table>
            </b-col>
            <b-row>
                <b-col>
                    <b-pagination class="float-right mt-4" v-model="pagination.page" :total-rows="pagination.total"
                        :next-text="$translate('next')" :prev-text="$translate('previous')" :per-page="pagination.pageSize"
                        aria-controls="roleTable" pills align="center"></b-pagination>
                </b-col>
            </b-row>
        </b-card-body>
    </b-card>
    </b-overlay>
</template>
<script>
import _ from 'lodash'
import moment from 'moment'
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'auditLogs-table',

    props: {
        type: {
            type: String,
        },
        title: String,
    },
    mixins: [permissionsMixins],
    data() {
        return {
            /** filter query */
            query: '',
            /** the current page being viewed */
            page: 1,
            tableLoading: false,
            /** the fields for the audit log table */
            filters: {
                type: null,
                user_id: null,
                date_from: null,
                date_to: null,
            },
        }
    },

    computed: {
        fields() {
            return [
                {
                    key: 'created_at',
                    label: this.$translate('date'),
                    formatter: (value, key, item) =>
                        moment(new Date(item.created_at)).format('YYYY-MM-DD hh:mm:A'),
                },
                { key: 'type', label: this.$translate('type') },
                { key: 'user', label: this.$translate('user'), formatter: (value) => `${value.first_name} ${value.last_name}` },
                { key: 'message', label: this.$translate('messages') },
            ]
        },
        auditTypes() {
            return this.$store.state.auditlogs.types
        },
        auditLogs() {
            return this.$store.state.auditlogs.items
        },
        pagination() {
            return this.$store.state.auditlogs.pagination || {}
        },
        users() {
            return this.$store.getters['users/sorted_officers'].map(x => ({
                value: x.id,
                text: x.name,
            }))
        },
        pageCount() {
            return Math.ceil(this.pagination.total / this.pagination.pageSize)
        },
    },

    watch: {
        auditLogs: {
            handler: function () {
                this.tableLoading = false
            },
            deep: true
        },
        'pagination.page': function (newPage) {
            if(this.page != newPage){
                this.changePage(newPage)
            }
            this.page = newPage
        },
        query: _.debounce(function (query) {
            this.$router.push({ query: { query } })
            this.doSearch()
        }, 200),
        'filters.user_id': function (filters) {
            console.log('filters', filters)
            this.doSearch()
        },

        'filters.type': function (filters) {
            console.log('filters', filters)
            this.doSearch()
        },

        'filters.date_from': function (filters) {
            console.log('filters', filters)
            this.doSearch()
        },

        'filters.date_to': function (filters) {
            console.log('filters', filters)
            this.doSearch()
        },
    },

    created() {
        this.$store.dispatch('users/fetchAll')
    },

    /** Search by filter criteria on component mount */
    mounted() {
        if (this.$route.query.query) this.query = this.$route.query.query
        this.doSearch()
    },

    methods: {
        changePage(page) {
            this.page = page
            this.$router.push({ query: { page: page } })
            this.doSearch()
        },
        doSearch() {
            this.tableLoading = true
            const { query, page, filters } = this
            this.$store.dispatch('auditlogs/types')
            this.$store.dispatch('auditlogs/fetch', {
                query,
                page,
                filters,
            })
        },
        truncate(text, length) {
            return _.truncate(text, { length: length })
        },
    },
}
</script>
<style></style>
